export const CONSENT_STORAGE_KEY = 'nj-cookie-consent';
export const CONSENT_CHANGE_EVENT = 'nj-cookie-consent:change';

export function getConsent() {
    if (typeof window === 'undefined') return null;
    try {
        const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object') return null;
        return {
            analytics: Boolean(parsed.analytics),
            marketing: Boolean(parsed.marketing),
        };
    } catch {
        return null;
    }
}

export function setConsent({ analytics, marketing }) {
    if (typeof window === 'undefined') return;
    const consent = {
        analytics: Boolean(analytics),
        marketing: Boolean(marketing),
    };
    try {
        window.localStorage.setItem(
            CONSENT_STORAGE_KEY,
            JSON.stringify(consent)
        );
    } catch {
        // ignore storage write issues
    }
    window.dispatchEvent(
        new CustomEvent(CONSENT_CHANGE_EVENT, { detail: consent })
    );
}
